import PropTypes from 'prop-types';

export const EventCalendarDayModel = PropTypes.shape({
  onClick: PropTypes.func,
  eventName: PropTypes.string,
  eventHour: PropTypes.arrayOf(
    PropTypes.shape({
      eventHourStart: PropTypes.string,
      eventHourEnd: PropTypes.string
    })
  )
});

export const EventCalendarDetailModel = PropTypes.shape({
  id: PropTypes.string,
  eventName: PropTypes.string,
  eventDate: PropTypes.string,
  eventConvener: PropTypes.string,
  eventLocation: PropTypes.string,
  docEvent: PropTypes.string,
  descriptionEvent: PropTypes.string,
  eventDays: PropTypes.arrayOf(
    PropTypes.shape({
      eventDay: PropTypes.string,
      eventHour: PropTypes.string
    })
  )
});

export const EventCalendarModel = PropTypes.shape({
  end: PropTypes.instanceOf(Date),
  eventCaller: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string
  }),
  hoursArray: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string,
      hours: PropTypes.arrayOf(
        PropTypes.shape({
          startTime: PropTypes.string,
          endTime: PropTypes.string
        })
      )
    })
  ),
  eventId: PropTypes.string,
  id: PropTypes.string,
  otherDays: PropTypes.arrayOf(PropTypes.string),
  start: PropTypes.instanceOf(Date),
  status: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string
});
